import * as _ from 'lodash';
import { AppEvent } from './eventNotification.service';

export interface GroupAppEvent extends AppEvent {
  subscribed: any;
  appEvent: {
    name: string;
    displayName: string;
  };
}

export default class OrganizationGroupsService {
  static $inject = ['$http'];

  baseUrl = '/aptitude/api/organizationgroups/';

  constructor(private $http) {
    'ngInject';
  }

  getOrganizationGroupDetails(
    organizationId: number,
    cache = true
  ): ng.IPromise<any> {
    return this.$http.get(`${this.baseUrl}${organizationId}`, { cache });
  }

  getGroupNotifications(
    organizationId: number,
    cache?
  ): ng.IPromise<GroupAppEvent[]> {
    return this.$http.get(
      `${this.baseUrl}${organizationId}/membernotifications`,
      { cache }
    );
  }
}
